import React from 'react';
import NavAdmin from "../nav-admin/nav-admin";

const HeaderCustomer = () => (
  <header className="HeaderCustomer">
      <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" aria-label="Customer header bar with admin navigation">
        <div className="container w-max2">
            <h5 className="sp-mx" id="customer-header-title">
                <i className="bi bi-globe2" aria-hidden="true"></i>
                    <span className="spacer-margin2 v-set4">Customers</span>
            </h5>
          <NavAdmin />
        </div>
      </nav>
  </header>
);

export default HeaderCustomer;
